import React from 'react'
import styled from 'styled-components'
import Container from './Container'

interface PageProps {
	background: string
	children: any
}
const Page: React.FC<PageProps> = ({ children, background }) => (
	<Layout background={background}>
		<PageContainer>{children}</PageContainer>
	</Layout>
)

interface LayoutProps {
	background: string
}

export const Layout = styled.div<LayoutProps>`
	flex: 1;
	display: flex;
	width: 100%;
	flex-direction: row;
	background: ${(props) =>
		`url(${props.background}) no-repeat center`};
	background-size: contain;
	background-repeat: no-repeat;
	background-attachment: fixed;
`

const PageContainer = styled(Container)`
	width: 100%;
	padding-top: 16px;
	padding-bottom: 16px;
	max-width: 1440px;
	background-repeat: no-repeat;
	background-position: center 0px, 0px 90%, 100% 90%;
	background-size: contain, 266px, 266px;
	@media (max-width: 576px) {
		background: none;
	}
`
export default Page
